// import PackageRequestMain from "../../../../features/customer/package-request/components/package-request-main";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import OfferRewardMain from "../../../../features/customer/offer-reward/components/offer-reward-main";

const title = "Offer & Reward";

const OfferRewardPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <OfferRewardMain />;
  // return "Customer Voucher Page";
};

export default OfferRewardPage;
